module.exports = __webpack_public_path__ + "img/image_arrow_r.fbfcccf9.png";